module.exports = __webpack_public_path__ + "static/img/px_2.e89ceb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/px_2.jpg
// module id = qKR5
// module chunks = 1